import { Text } from '@chakra-ui/react';
import React from 'react';
import { StyledStar } from './StarContainer';
import { PI_CLASSIC_COLORS } from '../theme/custom/custom-theme-colors';

export default function ThemeAwareStar() {
  return (
    <Text color={PI_CLASSIC_COLORS.highlightBorder}>
      <StyledStar fill="currentColor" width={50} height={50} />
    </Text>
  );
}
